import { render, staticRenderFns } from "./add-client.vue?vue&type=template&id=798f65eb&scoped=true&"
import script from "./add-client.vue?vue&type=script&lang=js&"
export * from "./add-client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798f65eb",
  null
  
)

export default component.exports